/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/tabs/custom-elements';

import { defineCustomElement as defineOsdsTabBar } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tab-bar.js';
import { defineCustomElement as defineOsdsTabBarItem } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tab-bar-item.js';
import { defineCustomElement as defineOsdsTabPanel } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tab-panel.js';
import { defineCustomElement as defineOsdsTabs } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tabs.js';


export const OsdsTabBar = /*@__PURE__*/ defineContainer<JSX.OsdsTabBar>('osds-tab-bar', defineOsdsTabBar);


export const OsdsTabBarItem = /*@__PURE__*/ defineContainer<JSX.OsdsTabBarItem>('osds-tab-bar-item', defineOsdsTabBarItem, [
  'panel',
  'active',
  'disabled',
  'contrasted',
  'odsTabItemSelectEvent'
]);


export const OsdsTabPanel = /*@__PURE__*/ defineContainer<JSX.OsdsTabPanel>('osds-tab-panel', defineOsdsTabPanel, [
  'active',
  'name'
]);


export const OsdsTabs = /*@__PURE__*/ defineContainer<JSX.OsdsTabs>('osds-tabs', defineOsdsTabs, [
  'contrasted',
  'panel',
  'size',
  'odsTabsChanged'
]);

